module.exports = __webpack_public_path__ + "img/BurrussHall1939.9aa54e4f.jpeg";